
export const menuMappping: any = {
  '': '',
  'admin_sys': '',
  'companies': 'companies',
  'cities': 'areas',
  'areas': 'areas',
  'agencies': 'agencies',
  'services': 'services',
  'users': 'users',
  'utilisateurs': 'users',
  'caisses': 'tills',
  'tills': 'tills',
  'recouvrement': 'recoveries',
  'transactions': 'transactions',

  //=======================> Supervisor menu mapping

  'accueil': '',
  'supervisor': '',
  'agences': 'agences',


  //=======================> Distributor menu mapping

  'distributor': '',
  'réception': 'reception',
  'reception': 'reception',
  'demandes': 'provisionning',
  'provisionning': 'provisionning',
  'partenaires': 'partners',
  'partners': 'partners',
  'profile': 'profile',
  'rapports': 'reports',


  //=======================> Cashier menu mapping

  'cashier': '',
  'mes demandes': 'request-for-appros',
  'mes rapports': 'daily-reports',
  'request-for-appros': 'request-for-appros',
  'ma caisse': 'my-till',
  'my-till': 'my-till',


}